import { QueryOptions } from "../../Common/useQuery";
import useUserQuery from "../../Common/useUserQuery";
import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";

export interface EmailSettingsDto {
  isEnabled: boolean;
  sendToCustomers: boolean;
  sendToBranches: boolean;
  sendToDrivers: boolean;
  sendToCarriers: boolean;
  sendToApplicators: boolean;
  queueCount: number;
  sentCount: number;
  failedCount: number;
  successRate: number;
}

const useGetEmailSettings = (options?: QueryOptions<EmailSettingsDto>) => {
  const business = useSelectedBusiness();

  return useUserQuery<EmailSettingsDto>(
    { path: `/api/businesses/${business.id}/emailSettings` },
    options);
}

export default useGetEmailSettings;